import { FONT } from "../../../value/staticValues";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";
import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";

import { ReactComponent as ActiveImg } from "../../../img/ico-status-badge-active.svg";
import { ReactComponent as InactiveImg } from "../../../img/ico-status-badge-idle.svg";
import { ReactComponent as RestoringImg } from "../../../img/ico-status-badge-commit.svg";
import { ReactComponent as LockedImg } from "../../../img/ico-status-badge-lock.svg";
import { ReactComponent as MigrationImg } from "../../../img/ico-status-badge-migration.svg";
import { ReactComponent as PoweringUpImg } from "../../../img/ico-status-badge-on.svg";
import { ReactComponent as PoweringDownImg } from "../../../img/ico-status-badge-off.svg";
import { ReactComponent as PausedImg } from "../../../img/ico-status-badge-pause.svg";
import { ReactComponent as SuspendImg } from "../../../img/ico-status-badge-stop.svg";
import { ReactComponent as RebootImg } from "../../../img/ico-status-badge-restart.svg";
import { ReactComponent as WaitForLaunchImg } from "../../../img/ico-status-badge-ready.svg";
import { ReactComponent as SavingImg } from "../../../img/ico-status-badge-sleep.svg";
import { ReactComponent as NotRespondingImg } from "../../../img/ico-status-badge-no-response.svg";
import { ReactComponent as UnknwonImg } from "../../../img/ico-status-badge-unknown.svg";

import { ListActionMenu, ListFilter, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";
import { DropdownType } from "../../base/CustomDropdown";
import { parseLocaleDatetime } from "common/util";


export interface RouterDetailData {
    router_id:string,
    router_name:string,
    router_description:string
    router_status:string,
    admin_state:string,
    ha_mode:string
    availability_zones:string,
    project: {
        project_id: string,
        project_name: string
    },
    create_ts: string,
    update_ts: string
}


export const initRouterDetailData = {
    router_id: "",
    router_name: "",
    router_description: "",
    router_status_code: "",
    ha_yn: true,
    up_yn: true,
    external_gateway_snat_yn: true,
    external_gateway_fixed_ip_address: "",
    all_availability_zone_yn: true,
    device_owner: "",
    network: {
        network_id: "",
        network_name: "",
        external_yn: true
    },
    subnet: {
        subnet_id: "",
        subnet_name: "",
        cidr: ""
    },
    project: {
        project_id: "",
        project_name: ""
    },
    availability_zone: [],
    network_ports: [],
    create_ts: "",
    update_ts: ""
}


export interface HostClusterTableData {
    host_id: string,
    host_name: string,
    ha_mode:string,
}



export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("HOST_ADD_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "HOST_ADD",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "HOST_DELETE",
        },
    },
    {
        id: 3,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "HOST_SYNC",
        }
    },
];



export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("ROUTER_TABLE_COLUMN_FIXED_IP_ADDRESS"),
        accessor: "fixed_ip_address",
        disableSortBy: false,
        style: {
            width: "50px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("ROUTER_TABLE_COLUMN_PORT_NAME_STATE"),
        accessor: "network_port_name",
        disableSortBy: true,
        style: {
            width: "200px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.blueText}}>{value}</div>
        )
    },
    {
        Header: i18n.t("ROUTER_TABLE_COLUMN_ROUTER_UP_MODE"),
        accessor: "up_yn",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value ? "#3a8344" : "#8c8c8c",
            }}>
                {
                    value ? <StatusStableImg style={className.statusImg}/> : <StatusBlockImg style={className.statusImg}/>
                }
                {
                    value ? "Up" : "Down"
                }
            </div>
        )
    },
    {
        Header: i18n.t("ROUTER_TABLE_COLUMN_ROUTER_STATUS"),
        accessor: "network_port_status_code",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value === "ACT" ? "#3a8344" : value === "ERR" ? "#e6735c": "#8c8c8c",
            }}>
                {
                    value === "ACT" ? "Active"
                    : value === "DWN" ? "Down"
                    : value === "BLD" ? "Build"
                    : "Error"
                }
            </div>
        )
    },
    {
        Header: i18n.t("ROUTER_TABLE_COLUMN_EXTERNAL_GATEWAY"),
        accessor: "router_external_gateway_yn",
        disableSortBy: true,
        style: {
            width: "60px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, color:"#4aaad4"}}>{value ? <StatusStableImg/> : <StatusBlockImg/>}</div>
        )
    }
];


export const hostClusterType:DropdownType[] = [
    {
        value: "NRM",
        label: i18n.t("NORMAL_TYPE_TEXT")
    },
    {
        value: "CMP",
        label: i18n.t("COMPUTE_TYPE_TEXT")
    },
    {
        value: "MEM",
        label: i18n.t("MEMORY_TYPE_TEXT")
    },
    {
        value: "GPU",
        label: i18n.t("GPU_TYPE_TEXT")
    },
    {
        value: "STRG",
        label: i18n.t("STORAGE_TYPE_TEXT")
    },
    {
        value: "NET",
        label: i18n.t("NIC_TYPE_TEXT")
    },
]

const className = {
    statusContainer: {
        width: 56,
        display: "flex", Jusitipy: "center", justifyContent: "center",
        borderRadius: 10,
        backgroundColor: "#b6bfce",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#fff"
    },
    nameTextContainer: {
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        color: "#333",
        overflow: "hidden"
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    blueContainer: {
        color: "#0853fb"
    },
    countContainer: {
        color: "#3a8344"
    },
    purpleText: {
        color: "#7066f1"
    },
    blueText: {
        color: "#0853fb"
    },
    greenText: {
        color: "#3a8344"
    },
    statusImg: {
        marginRight: 3
    },
}